<template>
<div class="header-box">
<dv-border-box-1 :backgroundColor="backgroundColor">
  <div class="header">
    <div class="line1">
      <div class="item" v-for="(item, index) in line1Data" :key="'line1' + index">
        <div>{{item.name}}</div>
        <div class="number">
          <dv-digital-flop :config="{
            number: [item.value],
            toFixed: 2,
            style: line1Style,
            animationCurve: 'easeOutCubic',
            animationFrame: 100
          }" style="width: 160px; height: 45px; transform: translateY(6px);"/>
          {{item.unit}}
        </div>
      </div>
    </div>

    <div class="line2">
      <div>
        <dv-digital-flop :config="{
          number: [line2Data],
          style: line2Style
        }" style=" height: 45px;"/>
        <div>综合</div>
        <div>运力指数</div>
      </div>
    </div>

    <div class="line3">
      <div v-for="(item, index) in line3Data" :key="'line3' + index">
        <div>{{item.name}}</div>
        <div class="number">
          <dv-digital-flop :config="{
              number: [item.value],
              toFixed: index === 0 ? 2 : 0,
              textAlign: 'right',
              style: line3Style,
              animationFrame: 100
            }" 
            style="width: 160px; height: 45px;"/>
          {{item.unit}}
        </div>
      </div>
    </div>
    <div class="line4">
      <dv-decoration-9 style="width:200px; height: 200px;">
        <div class="tip">
          <div class="percentage">
            <dv-digital-flop :config="{
              number: [line4Data],
              style: line4Style
            }" style="width: 50px; height: 40px;"/>
            <div>%</div>
          </div>
          <div>服务完成率</div>
        </div>
      </dv-decoration-9>
    </div>
  </div>
</dv-border-box-1>
</div>
</template>

<script>
import { line1Data, line3Data } from '../js/headerData'
import { getCompositeIndex } from '../../../api/colunm3'
export default {
  data () {
    return {
      line1Data: line1Data,
      line2Data: 0,
      line3Data: line3Data,
      line4Data: 99,
      backgroundColor: 'rgba(7, 32, 91, 0.5)',
      line1Style: {
        fill: '#34DEE5',
        fontSize: 30,
        fontWeight: 'bold'
      },
      line2Style: {
        fill: '#34DEE5',
        fontSize: 40,
        fontWeight: 'bold'
      },
      line3Style: {
        fill: '#34DEE5',
        fontSize: 40,
        fontWeight: 'bold'
      },
      line4Style: {
        fill: '#7ec699',
        fontSize: 50,
        fontFamily: 'DS-DIGIT'
      }
    }
  },

  created () {
    this.getData()
    setTimeout(() => {
      this.$forceUpdate()
    })
  },

  methods: {
    getData () {
      getCompositeIndex().then(res => {
        // this.line1Data[0].value = 0
        // const timer =  setTimeout(() => {
        //   this.line1Data[0].value = res.prices
        //   clearInterval(timer)
        // }, 100)
        this.line1Data[0].value = res.prices

        this.line1Data[1].value = Number(res.tfv)

        this.line2Data = Number(res.compositeIndex)

        this.line3Data[0].value = res.goodsOrders
        this.line3Data[1].value = res.companys
        this.line3Data[2].value = res.peopleNumber
        this.line4Data = Number(res.completionRate)
        this.timer && clearInterval(this.timer)
        this.timer = setTimeout(this.getData, 1000 * 10)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.header-box {
  height: 272px;
}

.header {
  display: flex;
  justify-content: space-between;
  height: 272px;
  padding: 15px 53px 16px 35px;
  // background-image: linear-gradient(
  //   -30deg,
  //   rgba(14, 49, 115, 0.5) 20%,
  //   rgba(12, 20, 54, 0.7),
  //   rgba(14, 49, 115, 0.5) 80%
  // );
}

.line1 {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .item {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 261px;
    height: 116px;
    padding: 14px 22px 10px 13px;
    border-radius: 20px;
    color: #fff;
    font-size: 22px;
    background-image: linear-gradient(0deg, #07205B 0%, #060D34 100%);
    .number {
      display: flex;
      align-items: flex-end;
    }
  }
}

.line2 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 222px;
  height: 222px;
  border-radius: 50%;
  background-image: url("~assets/image/ball.gif");
  background-size: 100% 100%;
  font-size: 21px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #FFFFFF;
  .font {
    color: #34DEE5;
    font-size: 40px;
    font-weight: bold;
  }
  & > div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}

.line3 {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  > div {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    width: 301px;
    height: 75px;
    padding: 0 11px 23px;
    border-radius: 12px;
    color: #fff;
    font-size: 17px;
    line-height: 17px;
    font-weight: bold;
    background: linear-gradient(0deg, #07205B 0%, #060D34 100%);
    .number {
      display: flex;
      align-items: flex-end;
      & > div {
        transform: translateY(10px);
      }
    }
  }
}

.line4  {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 222px;
  height: 222px;
  .tip {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #FFFFFF;
    .percentage {
      display: flex;
      align-items: flex-end;
      color: #7ec699;
      font-family: 'DS-DIGIT';
      // text-shadow: 0 0 3px rgb(122, 202, 236);
      > div:nth-child(2) {
        font-size: 16px;
      }
    }
    > div:nth-child(2) {
      font-size: 16px;
    }
  }
}
</style>
